import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path: string;
}

const routeLabels: Record<string, string> = {
  '': 'Inicio',
  'empresa': 'Empresa',
  'servicios': 'Servicios',
  'faq': 'Preguntas Frecuentes',
  'contacto': 'Contacto',
  'aviso-legal': 'Aviso Legal',
  'politica-privacidad': 'Política de Privacidad',
  'politica-cookies': 'Política de Cookies'
};

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const breadcrumbs: BreadcrumbItem[] = [
    { label: 'Inicio', path: '/' }
  ];

  let currentPath = '';
  pathnames.forEach((segment) => {
    currentPath += `/${segment}`;
    const label = routeLabels[segment] || segment;
    breadcrumbs.push({ label, path: currentPath });
  });

  // No mostrar breadcrumbs en la página de inicio
  if (pathnames.length === 0) {
    return null;
  }

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.label,
      "item": `https://pladurex.es${item.path}`
    }))
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <nav aria-label="Breadcrumb" className="bg-dark-card/50 border-b border-dark-lighter pt-20">
        <div className="container mx-auto px-4">
          <ol className="flex items-center space-x-2 py-3 text-sm overflow-x-auto">
            {breadcrumbs.map((item, index) => {
              const isLast = index === breadcrumbs.length - 1;
              
              return (
                <li key={item.path} className="flex items-center whitespace-nowrap">
                  {index > 0 && (
                    <i className="ri-arrow-right-s-line text-light-muted mx-2"></i>
                  )}
                  {isLast ? (
                    <span className="text-primary-orange font-medium" aria-current="page">
                      {item.label}
                    </span>
                  ) : (
                    <Link
                      to={item.path}
                      className="text-light-muted hover:text-light-text transition-colors flex items-center"
                    >
                      {index === 0 && (
                        <i className="ri-home-4-line mr-1"></i>
                      )}
                      {item.label}
                    </Link>
                  )}
                </li>
              );
            })}
          </ol>
        </div>
      </nav>
    </>
  );
};

export default Breadcrumbs;
